import React from "react";
import PropTypes from "prop-types";
//Limitless impirts
import { DevLoggingProvider } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { NotificationContextProvider } from "@limitless/common/hooks/notification/NotificationContext";
import { CustomerHistoryContextProvider } from "../hooks/customer-history/CustomerHistoryContext";
import { CustomerContextProvider } from "../hooks/customer/CustomerContext";
import { CustomerMessageContextProvider } from "../hooks/customer-message/CustomerMessageContext";
import { GroupResponseTimeContextProvider } from "../hooks/group-response-time/GroupResponseTimeContext";
import { WebSocketsContextProvider } from "@limitless/common/hooks/web-sockets/WebSocketsContext";
import { useCustomerWebSockets } from "../hooks/customer-web-sockets/CustomerWebSockets";
const CustomerLifecycleProvider = ({
  children,
  storageConfig,
  disableWebSockets = false,
  delayNonEssentialCalls = false
}) => {
  const renderChildren = () => {
    if (disableWebSockets) {
      return children;
    }
    return /*#__PURE__*/React.createElement(WebSocketsContextProvider, {
      eventProcessorHook: useCustomerWebSockets,
      shouldConnect: !delayNonEssentialCalls
    }, children);
  };
  return /*#__PURE__*/React.createElement(NotificationContextProvider, null, /*#__PURE__*/React.createElement(DevLoggingProvider, null, /*#__PURE__*/React.createElement(GroupResponseTimeContextProvider, {
    delayNonEssentialCalls: delayNonEssentialCalls
  }, /*#__PURE__*/React.createElement(CustomerContextProvider, {
    storageConfig: storageConfig
  }, /*#__PURE__*/React.createElement(CustomerHistoryContextProvider, {
    delayNonEssentialCalls: delayNonEssentialCalls
  }, /*#__PURE__*/React.createElement(CustomerMessageContextProvider, null, renderChildren()))))));
};
export default CustomerLifecycleProvider;
CustomerLifecycleProvider.propTypes = {
  children: PropTypes.node.isRequired,
  storageConfig: PropTypes.object,
  disableWebSockets: PropTypes.bool,
  delayNonEssentialCalls: PropTypes.bool
};